import React from 'react';
import CheckIcon from 'src/assets/images/svg/check.inline.svg';
import { LayoutBox } from '../Box';
import { Text } from '../Text';
import { StyledMenu, StyledMenuItem } from './Combobox.styled';

export const Menu = ({ getMenuProps, items, classicAppearance, size, styles, attributes, ...rest }) => (
  <StyledMenu
    {...getMenuProps({ itemsCount: items.length, classicAppearance, size })}
    onClick={event => {
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation(); // to prevent call of onClickOutside handler in Dropdown, etc
    }}
  >
    <MenuItemsList items={items} classicAppearance={classicAppearance} {...rest} />
  </StyledMenu>
);

const MenuItemsList = ({
  inputValue,
  items,
  isCreatable,
  formatCreateLabel,
  isValidNewItem,
  onCreate,
  getItemLabel,
  getItemValue,
  classicAppearance,
  selectedItemsMap,
  ...rest
}) => {
  if (!items.length && (!isCreatable || !isValidNewItem || !inputValue)) {
    return <StyledMenuItem>No options</StyledMenuItem>;
  }
  if (isCreatable && !items.length && inputValue) {
    return <StyledMenuItem onClick={() => onCreate(inputValue)}>{formatCreateLabel(inputValue)}</StyledMenuItem>;
  }
  return items.map((item, index) =>
    item.items ? (
      <div className="group">
        <Text mb="5px" color="textPrimary" fontWeight="bold">
          {getItemLabel(item)}
        </Text>
        {item.items.map((item, innerIndex) => (
          <MenuItem
            key={getItemValue(item)}
            index={items.slice(0, index).reduce((acc, item) => acc + item.items?.length || 0, innerIndex)}
            {...{ item, classicAppearance, selectedItemsMap, getItemValue, getItemLabel }}
            {...rest}
          />
        ))}
      </div>
    ) : (
      <MenuItem
        key={getItemValue(item)}
        {...{ item, classicAppearance, selectedItemsMap, getItemValue, getItemLabel, index }}
        {...rest}
      />
    )
  );
};

const MenuItem = ({
  getItemProps,
  item,
  index,
  highlightedIndex,
  classicAppearance,
  selectedItemsMap,
  getItemValue,
  getItemLabel
}) => (
  <StyledMenuItem isHighlighted={highlightedIndex === index} {...getItemProps({ item, index })}>
    {classicAppearance && (
      <LayoutBox mr={5} width={10} minWidth={10}>
        {selectedItemsMap[getItemValue(item)] && <CheckIcon />}
      </LayoutBox>
    )}
    <Text textStyle="ellipsis">{getItemLabel(item)}</Text>
  </StyledMenuItem>
);
